
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Partner from "../pages/partner/page";
import Recruit from "../pages/recruit/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/partner",
    element: <Partner />,
  },
  {
    path: "/recruit",
    element: <Recruit />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
